import React, { useState } from "react";
import Avatar from "./Avatar";
import styled from "styled-components";
import { EditIcon } from "../assets/svg/EditIcon";
import { TitleText } from "./Text";
import { DeleteIcon } from "../assets/svg/DeleteIcon";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { TableEditIcon } from "../assets/svg/TableEditIcon";
import CommentIcon from "../assets/svg/CommentIcon";
import { CloseIcon } from "../assets/svg/CloseIcon";
import { CloseIcon2 } from "../assets/svg/CloseIcon2";

interface Iprops {
  name: any;
  url: string;
  email?: string;
  hasEmail?: boolean;
}

interface EditProps {
  showEdit?: any;
  onClick?: any;
  handleDelete?: any;
  hasComments?: boolean;
  toggleComment?: any;
  isArchived?: boolean;
  handleClosePeriod?: any;
  isActive?: boolean;
}

export const EditDeleteFormatter = ({
  showEdit,
  onClick,
  handleDelete,
  hasComments,
  handleClosePeriod,
  toggleComment,
  isArchived,
  isActive,
  ...props
}: EditProps) => {
  const [visible, setVisible] = useState(false);
  const show = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setVisible(true);
  };
  const hide = (e) => {
    setVisible(false);
  };

  return (
    <ToolTip
      interactive={true}
      delay={100}
      placement="bottom-end"
      visible={isActive ? false : visible}
      arrow={false}
      onClickOutside={hide}
      content={
        <EditContainer>
          <EditIcon />
          <TitleText
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              showEdit();

              hide(e);
            }}
          >
            Edit
          </TitleText>
          <DeleteIcon />
          <TitleText
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleDelete();
              hide(e);
            }}
          >
            Delete
          </TitleText>
          {hasComments && (
            <>
              <CommentIcon />
              <TitleText
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleComment();
                  hide(e);
                }}
              >
                Comment
              </TitleText>
            </>
          )}
          {handleClosePeriod && (
            <>
              <CloseIcon2 />
              <TitleText
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleClosePeriod();
                  hide(e);
                }}
              >
                Close
              </TitleText>
            </>
          )}
        </EditContainer>
      }
    >
      <EditIconContainer
        visible={isActive ? false : visible}
        onClick={visible ? hide : show}
      >
        <TableEditIcon />
      </EditIconContainer>
    </ToolTip>
  );
};

const TableFormatter = ({ name, url, email, hasEmail }: Iprops) => {
  return (
    <div
      style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      <Avatar url={url} />
      {hasEmail ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "1em",
          }}
        >
          <span>{name}</span>
          <span style={{ fontSize: 12, fontWeight: "normal", marginTop: 10 }}>
            {email}
          </span>
        </div>
      ) : (
        <span style={{ paddingLeft: "1em" }}>{name}</span>
      )}
    </div>
  );
};

export default TableFormatter;

const EditContainer = styled.div`
  display: grid;
  grid-template-columns: 2em 5em;
  grid-template-rows: repeat(2, 2em);
  align-items: center;
  row-gap: 0.5em;
  padding: 0.75em;
  border-radius: 0.5em;
  background-color: #fff;
  ${TitleText} {
    cursor: pointer;
    font-size: 12px;
  }
`;

const EditIconContainer = styled.div<{ visible: boolean }>`
  position: relative;
  height: 1em;
  width: 1em;
  display: flex;
  align-items: center;
  padding: 0.5em;
  justify-content: center;
  border-radius: 50%;
  background-color: ${(props) => (props.visible ? "#f7f8ff" : "")};
`;

const ToolTip = styled(Tippy)`
  padding: 0;
  background-color: white;
  font-size: 10px;
  margin-top: -1rem;
  box-shadow: 1px 1px 3px #888888;
  width: 10em;
`;
